import { createSlice } from "@reduxjs/toolkit"
import {toast, ToastContainer } from "react-toastify"

export const userInfoSlice = createSlice({
	name: "users",
	initialState: {
		users: [],
		userPhone: "",
		errors: [],
	},

	reducers: {
		getUsers: (state, action) => {
			state.users = action.payload
			// console.log(action.payload, "reducer")
		},
		getUserPhone: (state, action) => {
			// console.log(action, "reducer")
			state.userPhone = action.payload.phone
			// state.userPhone = action.payload.reset_phone
		},

		getUserSuccess: (state, action) => {
			state.users = action.payload
			// console.log(action.payload, "reducer")
		},

		getErrors: (state, action) => {
			state.errors = action.payload
			// console.log(action.payload, "error from reducer")

			/* user signup error message*/
			if(state.errors.password1){
				toast.error(`${state.errors.password1}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
			
			else if(state.errors.full_name){
				toast.error(`${state.errors.full_name}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
			else if(state.errors.non_field_errors[0]){
				toast.error(`${state.errors.non_field_errors[0]}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
		},
	},
})

// Action creators are generated for each case reducer function
export const {getUsers, getErrors, getUserSuccess, getUserPhone} = userInfoSlice.actions

export default userInfoSlice.reducer
